/** Match the blade shader's float32 random selection, then bucket instances so
 * a conservative prefix contains every blade that can survive its density law.
 * This removes rejected vertices before submission, without thinning the sward. */
export const GRASS_DENSITY_BUCKETS = 256;

export function grassDensityPick(random: number): number {
  const x = Math.fround(Math.fround(random) * Math.fround(97.31));
  return x - Math.floor(x);
}

/** A spatial subset of an already ordered field retains its density order. */
export function grassDensityEnds(data: Float32Array, count: number): Uint32Array {
  const ends = new Uint32Array(GRASS_DENSITY_BUCKETS);
  for (let i = 0; i < count; i++) ends[Math.min(ends.length - 1, Math.floor(grassDensityPick(data[i * 4 + 3]) * ends.length))]++;
  for (let i = 1; i < ends.length; i++) ends[i] += ends[i - 1];
  return ends;
}

export function orderGrassInstances(arrays: { array: Float32Array | Float64Array; size: number }[], count: number): Uint32Array {
  const data = arrays[0].array;
  const buckets = new Uint16Array(count), ends = new Uint32Array(GRASS_DENSITY_BUCKETS);
  for (let i = 0; i < count; i++) {
    const b = Math.min(GRASS_DENSITY_BUCKETS - 1, Math.floor(grassDensityPick(data[i * 4 + 3]) * GRASS_DENSITY_BUCKETS));
    buckets[i] = b; ends[b]++;
  }
  for (let b = 1; b < ends.length; b++) ends[b] += ends[b - 1];
  const next = new Uint32Array(GRASS_DENSITY_BUCKETS);
  next.set(ends.subarray(0, -1), 1);
  const order = new Uint32Array(count);
  for (let i = 0; i < count; i++) order[next[buckets[i]]++] = i;
  for (const { array, size } of arrays) {
    const source = array.slice(0, count * size);
    for (let i = 0; i < count; i++) for (let j = 0; j < size; j++) array[i * size + j] = source[order[i] * size + j];
  }
  return ends;
}

export function grassInstanceCount(ends: Uint32Array, nearest: number, nearFull: number): number {
  const x = Math.min(1, nearFull / Math.max(nearest, nearFull));
  // An extra bucket covers shader rounding at the threshold. The shader still
  // handles the individual distance and growth ramp of every submitted blade.
  const bucket = Math.min(ends.length - 1, Math.floor(x * Math.sqrt(x) * ends.length) + 1);
  return ends[bucket];
}
